export enum MatType {
	LINE_BASIC = 'lineBasic',
	LINE_BASIC_BUILDER = 'lineBasicBuilder',
	MESH_BASIC = 'meshBasic',
	MESH_BASIC_BUILDER = 'meshBasicBuilder',
	MESH_DEPTH_BUILDER = 'meshDepthBuilder',
	MESH_DISTANCE_BUILDER = 'meshDistanceBuilder',
	MESH_LAMBERT = 'meshLambert',
	MESH_LAMBERT_BUILDER = 'meshLambertBuilder',
	MESH_MATCAP = 'meshMatcap',
	MESH_NORMAL = 'meshNormal',
	MESH_PHONG = 'meshPhong',
	MESH_PHONG_BUILDER = 'meshPhongBuilder',
	MESH_PHYSICAL = 'meshPhysical',
	MESH_PHYSICAL_BUILDER = 'meshPhysicalBuilder',
	MESH_STANDARD = 'meshStandard',
	MESH_STANDARD_BUILDER = 'meshStandardBuilder',
	MESH_TOON = 'meshToon',
	MESH_TOON_BUILDER = 'meshToonBuilder',
	POINTS = 'points',
	POINTS_BUILDER = 'pointsBuilder',
	RAY_MARCHING_BUILDER = 'rayMarchingBuilder',
	SHADOW = 'shadow',
	SKY = 'sky',
	VOLUME = 'volume',
	VOLUME_BUILDER = 'volumeBuilder',
}
